import { render, staticRenderFns } from "./UsercomListingBanner.vue?vue&type=template&id=52473f21&scoped=true&"
import script from "./UsercomListingBanner.vue?vue&type=script&lang=ts&"
export * from "./UsercomListingBanner.vue?vue&type=script&lang=ts&"
import style0 from "./UsercomListingBanner.vue?vue&type=style&index=0&id=52473f21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52473f21",
  null
  
)

export default component.exports